import axios from 'axios';
import requestInterceptor from './requestInterceptor';

const defaultMimeType = 'application/json';

const shareUrlApiInstance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: { 'Content-Type': defaultMimeType, Accept: defaultMimeType }
});

// Add a request interceptor
shareUrlApiInstance.interceptors.request.use(requestInterceptor);

export default shareUrlApiInstance;



// WEBPACK FOOTER //
// ./src/common/api/shareUrlApi.js